import { createReducer, ActionType } from "typesafe-actions";
import * as actions from "./actions";
import initialState from "./state";
import { ToolbarState } from "./types";
import { WHOLE_SECTION_COMMENTS_MAX_COUNT } from "./constants";

type Action = ActionType<typeof actions>;

const reducer = createReducer<ToolbarState, Action>(initialState)
  .handleAction(actions.toggleShowAnswers, (state) => ({
    ...state,
    showAnswers: !state.showAnswers,
  }))
  .handleAction(actions.toggleDictionary, (state) => ({
    ...state,
    dictionary: {
      ...state.dictionary,
      isEnabled: !state.dictionary.isEnabled,
    },
  }))
  .handleAction(actions.showDictionaryTooltip, (state, { payload }) => ({
    ...state,
    dictionary: {
      ...state.dictionary,
      tooltip: {
        isShown: true,
        left: payload.left,
        top: payload.top,
      },
    },
  }))
  .handleAction(actions.hideDictionaryTooltip, (state) => ({
    ...state,
    dictionary: {
      ...state.dictionary,
      tooltip: {
        isShown: false,
        left: 0,
        top: 0,
      },
    },
  }))
  .handleAction(actions.setDictionaryWord, (state, { payload }) => ({
    ...state,
    dictionary: {
      ...state.dictionary,
      word: payload,
    },
  }))
  .handleAction(actions.fetchComments.request, (state, { payload }) => ({
    ...state,
    filter: payload,
    wholeSectionCommentsLoading: true,
  }))
  .handleAction(actions.fetchComments.success, (state) => ({
    ...state,
    wholeSectionCommentsLoading: false,
  }))
  .handleAction(actions.fetchComments.failure, (state) => ({
    ...state,
    wholeSectionCommentsLoading: false,
  }))
  .handleAction(actions.setComments, (state, { payload }) => ({
    ...state,
    wholeSectionComments: payload,
  }))
  .handleAction(actions.setShowCommentsForPrint, (state, { payload }) => ({
    ...state,
    showCommentsForPrint: payload,
  }))
  .handleAction(actions.editWholeSectionComment, (state) => {
    let { wholeSectionComments } = state;

    // open a edit form for existing comments or create a new one
    if (wholeSectionComments.length <= WHOLE_SECTION_COMMENTS_MAX_COUNT) {
      wholeSectionComments = wholeSectionComments.some(
        (comment) => !comment.readonly,
      )
        ? wholeSectionComments.map((comment) =>
            comment.readonly ? comment : { ...comment, mode: "edit" },
          )
        : wholeSectionComments.concat([{ mode: "edit", comment: "" }]);
    }

    return {
      ...state,
      wholeSectionComments,
    };
  })
  .handleAction(actions.setSpeechEnabled, (state, { payload }) => ({
    ...state,
    speechEnabled: payload,
  }))
  .handleAction(actions.setPrintEnabled, (state, { payload }) => ({
    ...state,
    printEnabled: payload,
  }))
  .handleAction(actions.setScenarioDescription, (state, { payload }) => ({
    ...state,
    scenarioDescription: payload,
  }))
  .handleAction(actions.setAvailableCalculators, (state, { payload }) => ({
    ...state,
    calculator: {
      fourFunctionCalculator: !!payload?.fourFunctionCalculator,
      scientificCalculator: !!payload?.scientificCalculator,
      graphingCalculator: !!payload?.graphingCalculator,
    },
  }));

export default reducer;
